import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateClusterResponsiblePerson(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $employeeId: ID!
    $input: SpaceResponsiblePersonInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateClusterResponsiblePerson(
                  clusterId: $clusterId
                  employeeId: $employeeId
                  input: $input
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.UpdateClusterResponsiblePersonMutation,
  undefined,
  graphql.schema.UpdateClusterResponsiblePersonMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
